module.exports = __webpack_public_path__ + "static/img/young gee.88fe951.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/young gee.jpg
// module id = iAp9
// module chunks = 1